import { gql } from 'apollo-boost';
import { useIdsFromUrlWithoutParse } from 'core/hooks/useIdsFromUrl';
import { useGetArticleQuery } from 'site/graphql';

gql`
    query GetArticle($slug: String!) {
        articleBySlug(slug: $slug) {
            id
            title
            slug
            shortDescription
            content
            isVisible
            account {
                id
                firstName
                lastName
            }
            suggestedProduct {
                id
                name
                pictureId
            }
            suggestedArticles {
                id
                title
                slug
                pictureBigId
                tags
                date
                account {
                    id
                    firstName
                    lastName
                }
            }
            date
            pictureBigId
            pictureSmallId
            pageViews
            tags
        }
    }
`;

const useArticleData = () => {
    const { slug } = useIdsFromUrlWithoutParse('slug');

    const { data, loading } = useGetArticleQuery({ variables: { slug } });
    const article = data && data.articleBySlug;

    return [article, loading] as const;
};

export default useArticleData;
